export enum AlertType {
  Danger = 'danger',
  Success = 'success',
  Information = 'information',
}
